import React, { useEffect } from "react";
import styles from "./Projects.module.scss";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Work from "../Work/Work";
import Project from "./Project/Project";

import dashbo from "../../../assets/projects/dashbo.png";
import dashboM from "../../../assets/projects/dashboM.png";
import payyd from "../../../assets/projects/payyd.png";
import payydM from "../../../assets/projects/payydM.png";
import aiTutor from "../../../assets/projects/aiTutor.png";
import aiTutorM from "../../../assets/projects/aiTutorM.png";
import directPay from "../../../assets/projects/directpay.png";
import directPayM from "../../../assets/projects/directpayM.png";
import cryptoClash from "../../../assets/projects/cryptoClash.png";
import cryptoClashM from "../../../assets/projects/cryptoClashM.png";
import apelyze from "../../../assets/projects/apelyze.png";
import apelyzeM from "../../../assets/projects/apelyzeM.png";
import immiFellow from "../../../assets/projects/immiFellow.png";
import immiFellowM from "../../../assets/projects/immiFellowM.png";

const Projects = () => {
  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    if(isMobile) return;
    gsap.registerPlugin(ScrollTrigger);
    let container = document.getElementById("projectsContainer");
    let lastProgress = 0; // Track the last position

    gsap.to(container, {
      x: () =>
        -(container.scrollWidth - document.documentElement.clientWidth) + "px",
      ease: "none",
      scrollTrigger: {
        trigger: container,
        invalidateOnRefresh: true,
        pin: true,
        scrub: 2, // Much slower scroll - high resistance
        end: () => "+=" + container.offsetWidth,
        snap: {
          snapTo: (progress) => {
            const numProjects = 7;
            
            // Calculate current project index
            const currentProjectIndex = Math.round(lastProgress * numProjects);
            const newProjectIndex = Math.round(progress * numProjects);
            
            // Limit movement to maximum 1 project at a time for very controlled navigation
            const maxJump = 1;
            const difference = newProjectIndex - currentProjectIndex;
            
            let targetIndex;
            if (Math.abs(difference) > maxJump) {
              // Limit the jump to maxJump projects
              if (difference > 0) {
                targetIndex = currentProjectIndex + maxJump;
              } else {
                targetIndex = currentProjectIndex - maxJump;
              }
            } else {
              targetIndex = newProjectIndex;
            }
            
            // Ensure we stay within bounds
            targetIndex = Math.max(0, Math.min(numProjects, targetIndex));
            
            // Calculate the snap position
            const snapPosition = targetIndex / numProjects;
            
            // Update last progress for next calculation
            lastProgress = snapPosition;
            
            return snapPosition;
          },
                     duration: { min: 0.6, max: 1.5 }, // Much longer snap duration for very smooth feel
           delay: 0.2, // Longer delay to prevent quick jumps
        },
        onUpdate: (self) => {
          // Update lastProgress during scroll for better tracking
          lastProgress = self.progress;
        },
      },
    });
  }, [isMobile]);

  const data = [
    {
      title: "NFT Dashbo",
      description:
        "DashBO.XYZ grants NFT owners unparalleled access to an AI-powered dashboard. This innovative and streamlined platform empowers individuals from all backgrounds, regardless of their technical expertise, to build and cultivate their intellectual property from their profile picture (NFT). It serves as a springboard for creativity and personal expression, offering a wide array of tools and functionalities that provide users with unprecedented control over their profile picture (NFT).",
      projectImage: dashbo,
      hoverImage: dashboM,
      link: "https://dashbo.xyz/",
    },
    {
      title: "Payyd",
      description:
        "Payyd is an integrated technology layer which sits on top of established banks and financial institutions providing direct connectivity and payments localisation for enterprises and merchants globally. We make it easy for you to do business worldwide.",
      projectImage: payyd,
      hoverImage: payydM,
      link: "https://payyd.money/",
    },
    {
      title: "AI Tutor",
      description:
        "Unlimited Foreign Language Conversation Practice. Personalized speaking practice without the anxiety. Available 24/7 - for a fraction of the cost of a human teacher.",
      projectImage: aiTutor,
      hoverImage: aiTutorM,
      link: "https://yourteacher.ai/",
    },
    {
      title: "DirectPay",
      description:
        "To connect organisations and people globally to the payments network that helps them thrive.",
      projectImage: directPay,
      hoverImage: directPayM,
      link: "https://directpay.money/",
    },
    {
      title: "Crypto Clash",
      description:
        "The game is a decentralized finance (DeFi) platform, which allows players to make predictions on the price of Bitcoin. Players can join pools that predict whether the price will go up or down, and invest a certain amount of Polygon (MATIC) to participate. The game uses smart contracts to ensure the integrity and security of the game's results.",
      projectImage: cryptoClash,
      hoverImage: cryptoClashM,
      link: "https://info.cryptoclash.gg/",
    },
    {
      title: "Apelyze",
      description:
        "All-in-one platform for APEChain NFT analytics, mint alerts, whale tracking, and portfolio management.",
      projectImage: apelyze,
      hoverImage: apelyzeM,
      link: "https://apelyze.com/",
    },  
    {
      title: "ImmiFellow",
      description:
        "Get real immigration insights from people who were once in your shoes.Skip the consultants book a 1-on-1 call with someone from your home country now living your dream.",
      projectImage: immiFellow,
      hoverImage: immiFellowM,
      link: "https://immifellow.com/",
    },
  ];

  return (
    <div id="projectsContainer">
      <Work />

      <div className={styles.container}>
        {data.map((e, index) => (
          <div key={index} className={styles.module}>
            <Project
              title={e.title}
              description={e.description}
              projectImage={e.projectImage}
              hoverImage={e.hoverImage}
              link={e.link}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
